export default __webpack_public_path__ + "static/media/jaguar.d366ed42.webp";